import(/* webpackMode: "eager" */ "/codebuild/output/src3001039359/src/core-admin-app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3001039359/src/core-admin-app/src/app/providers/AppProviders.js");
